import axios from "axios";
import authHeader from "./auth-header";
import { checkEnvType } from "src/helper";
import { setMessage } from "src/slices/message";
import store from '../store'

const isDevelopment = checkEnvType();
const API_URL = isDevelopment ? process.env.REACT_APP_API_DEV_URL : process.env.REACT_APP_API_PROD_URL;



const instance = axios.create({
  baseURL: API_URL,
});
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const message = (error.response && error.response.data && error.response.data.message) ||
      error.message || error.toString();
    store.dispatch(setMessage({ message, isError: true }));
    return Promise.reject(error);
  }
);

const addFrontPage = async (title, category, description, image, isActive) => {
  return await axios
    .post(API_URL + "admin/addfrontpage", {
      title,
      category,
      description,
      image,
      isActive,
    }, {
      headers: authHeader()
    })
    .then((response) => {
      return response.data;
    });
};

const addInnerFront = async (title, category, content, innerImage, price, id) => {
  return await axios
    .patch(API_URL + `admin/addinnerfront/${id}`, {
      title, category, content, innerImage, price
    }, {
      headers: authHeader()
    })
    .then((response) => {
      return response.data;
    });
};

const getFrontPage = async () => {
  return await instance
    .get(API_URL + "admin/frontpage", {
      headers: authHeader()
    })
    .then((response) => {
      return response.data;
    });
};


const updateFrontPage = async (id, isActive) => {
  return await axios
    .patch(API_URL + `admin/updatefrontPage/${id}`, { isActive }, {
      headers: authHeader()
    })
    .then((response) => {
      return response.data;
    });
};

const updateFrontPageData = async (id, title, category, description, image, oldImage) => {
  return await axios
    .put(API_URL + `admin/updatefrontpage/${id}`, {
      title,
      category,
      description,
      image,
      oldImage
    }, {
      headers: authHeader()
    })
    .then((response) => {
      return response.data;
    });
};

const updateContent = async (id, content) => {
  return await axios
    .patch(API_URL + `admin/updatefrontcontent/${id}`, { content }, {
      headers: authHeader()
    })
    .then((response) => {
      return response.data;
    });
};

const deleteFrontPage = async (id) => {
  return await axios
    .delete(API_URL + `admin/deletefrontpage/${id}`, {
      headers: authHeader()
    })
    .then((response) => {
      return response.data;
    });
};

const deleteInnerFront = async (id, frontId, oldImage) => {
  return await axios
    .patch(API_URL + `admin/deleteinnerfront/${id}`, {
      frontId,
      oldImage
    }, {
      headers: authHeader()
    })
    .then((response) => {
      return response.data;
    });
};

const frontPageService = { addFrontPage, addInnerFront, getFrontPage, updateFrontPage, updateContent, deleteInnerFront, updateFrontPageData, deleteFrontPage };
export default frontPageService;